var map = {
	"./arrowright.svg": 427,
	"./calendar.svg": 428,
	"./calories.svg": 429,
	"./check.svg": 430,
	"./close.svg": 431,
	"./cocktail.svg": 432,
	"./demi.svg": 433,
	"./deplier.svg": 434,
	"./deplierblue.svg": 435,
	"./deplierred.svg": 436,
	"./doodle_fleche_court.svg": 437,
	"./edition.svg": 438,
	"./facebook.svg": 439,
	"./fort.svg": 440,
	"./iddle.svg": 441,
	"./letters-access.svg": 442,
	"./logoais.svg": 443,
	"./mail.svg": 444,
	"./men.svg": 445,
	"./menu-close.svg": 446,
	"./menu.svg": 447,
	"./money.svg": 448,
	"./newlogo.svg": 449,
	"./newlogowithoutbaseline.svg": 450,
	"./portefeuille.svg": 451,
	"./smartphone.svg": 452,
	"./smiley.svg": 453,
	"./suivant.svg": 454,
	"./tada.svg": 455,
	"./twitter.svg": 456,
	"./vin.svg": 457
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 426;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons nonrecursive .*\.svg$
// module id = 426
// module chunks = 0